import styles from './UserAlreadyExistsModal.module.css'
import { useTranslations } from 'next-intl'
import LinkButton, { LinkButtonKind, LinkButtonSize } from '@/components/UI/Buttons/LinkButton/LinkButton'

interface UserAlreadyExistsModalProps extends React.HTMLAttributes<HTMLDivElement> {
  onClose: () => void
}

export default function UserAlreadyExistsModal ({ onClose }: UserAlreadyExistsModalProps) {
  const t = useTranslations('Modals.UserAlreadyExists')

  return (
    <div className={styles.userAlreadyExistsModal}>
      <div className={styles.contentWrapper}>
        <p className={`title3 ${styles.content}`}>{t('content')}</p>
      </div>

      <div className={styles.buttons}>
        <LinkButton href={'/login'} internal={true} kind={LinkButtonKind.SUGGESTED} size={LinkButtonSize.MEDIUM} onClick={onClose}>
          {t('login')}
        </LinkButton>
      </div>
    </div>
  )
}